import { UserType } from "globals/types/models.ts";
import { useAppSelector } from "config/store";
import { USER_TYPES } from "globals/constants.ts";
import EventManagerProfilePage from "pages/profile/EventManagerProfilePage.tsx";
import ViewerProfilePage from "pages/profile/ViewerProfilePage.tsx";

function SwitchProfilePage() {
  const currentUser: UserType | null = useAppSelector(state => state.auth.user);


  if (currentUser?.type === USER_TYPES.EVENT_MANAGER) {
    return <EventManagerProfilePage />;
  }

  if (currentUser?.type === USER_TYPES.VIEWER) {
    return <ViewerProfilePage />;
  }

  return null;
}

export default SwitchProfilePage;
